import { z } from 'zod';

import { withCache } from '~/api/cache';
import { fetchApi } from '~/api/core';

const DEFAULT_CACHE_DURATION_MS = 60 * 1000; // 60秒

export const ZodMenuItem = z.object({
  label: z.string(),
  href: z.string(),
});

const ZodLogo = z.object({
  src: z.string(),
  href: z.string(),
  alt: z.string(),
});

const ZodLoginButton = z.object({
  text: z.string(),
  hrefPath: z.string(),
  hrefSearchParamKey: z.string(),
});

const ZodPoint = z.object({
  href: z.string(),
});

const ZodGlobalConfigHeader = z.object({
  logo: ZodLogo,
  loginButton: ZodLoginButton,
  point: ZodPoint,
  stockPrice: z.string(),
  serviceMenus: z.array(ZodMenuItem),
  menusIfLogin: z.array(ZodMenuItem),
  menusIfNotLogin: z.array(ZodMenuItem),
  bottomMenusIfLogin: z.array(ZodMenuItem),
  bottomMenusIfNotLogin: z.array(ZodMenuItem),
});
export type ServiceMenus = z.infer<typeof ZodMenuItem>[];
export type GlobalConfigHeader = z.infer<typeof ZodGlobalConfigHeader>;

const ZodGlobalConfigFooter = z.object({
  items: z.array(ZodMenuItem),
  copyright: z.string(),
});
export type GlobalConfigFooter = z.infer<typeof ZodGlobalConfigFooter>;

export const ZodGlobalConfig = z.object({
  header: ZodGlobalConfigHeader,
  footer: ZodGlobalConfigFooter,
});

export type GlobalConfig = z.infer<typeof ZodGlobalConfig>;

const getGlobalConfigUncached = async () =>
  fetchApi(import.meta.env.VITE_APP_KABUAND_GLOBAL_CONFIG_URL, undefined, ZodGlobalConfig);

export const getGlobalConfig = withCache(getGlobalConfigUncached, DEFAULT_CACHE_DURATION_MS);
